
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import BaseRabotaAgroBookCard from '@rshb/rshb-vue-kit/src/projects/rabotaAgro/cards/BaseRabotaAgroBookCard.vue'
import { BookCardModel } from '~/model'

@Component({
  components: {
    BaseRabotaAgroBookCard
  }
})
export default class extends Vue {
  @Prop({
    default: () => ({
      id: '',
      author: '',
      name: '',
      image: '',
      slug: ''
    })
  })
  readonly bookCard!: BookCardModel

  clickCard(slug: string) {
    this.$emit('on-click-card', slug)
  }
}
